export default __webpack_public_path__ + "static/media/servicewebsitedesign.4afc5354.jpeg";